import { Pipe, PipeTransform } from '@angular/core';

/** Shows the text with linebreaks **/
@Pipe({ name: 'linebreak' })
export class LinebreakPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.replace(/\n/g, '<br>');
  }
}
